export default __webpack_public_path__ + "static/lootboxes-min-25e3d5360a3d9b40b5fe690a06f079e5.png";